var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDcDeleteGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#aeb0b0;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.05,22.74a3.62,3.62,0,0,0,3.62,3.63V44.51a7.27,7.27,0,0,0,7.26,7.26H39.07a7.27,7.27,0,0,0,7.26-7.26V26.37A3.64,3.64,0,0,0,50,22.74V19.12a3.64,3.64,0,0,0-3.63-3.63H39.07V11.86a3.62,3.62,0,0,0-3.63-3.63H24.56a3.62,3.62,0,0,0-3.63,3.63v3.63H13.67A3.64,3.64,0,0,0,10,19.12ZM42.7,44.51a3.62,3.62,0,0,1-3.63,3.63H20.93a3.62,3.62,0,0,1-3.63-3.63V26.37H42.7ZM24.56,11.86H35.44v3.63H24.56ZM13.67,19.12H46.33v3.62H13.67Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.74,44.51a1.81,1.81,0,0,0,1.82-1.81V31.81a1.82,1.82,0,0,0-3.63,0V42.7a1.81,1.81,0,0,0,1.81,1.81Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,44.51a1.81,1.81,0,0,0,1.81-1.81V31.81a1.83,1.83,0,0,0-.9-1.57,1.85,1.85,0,0,0-1.82,0,1.83,1.83,0,0,0-.9,1.57V42.7A1.81,1.81,0,0,0,30,44.51Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.26,44.51a1.81,1.81,0,0,0,1.81-1.81V31.81a1.82,1.82,0,0,0-3.63,0V42.7A1.81,1.81,0,0,0,36,44a1.83,1.83,0,0,0,1.29.53Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcDeleteGray);
export default __webpack_public_path__ + "static/media/DC__Delete_gray.790540f6f5e225dfa90a3af7fe33c4d7.svg";
export { ForwardRef as ReactComponent };